import Route from '@ember/routing/route';
import urlBuilder from 'garaje/utils/url-builder';

export default class AuthRoute extends Route {
  beforeModel() {
    window.location = `${urlBuilder.authn.authorize()}${window.location.search}`;
  }
}
